import React from 'react'
import { Button, Container, TextBody, FieldText } from '@pmi/pmi-iqos-ds-react'
import { goTo, Routes, htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const Coupon = ({
  translations,
  handleCouponAction,
  handleChangeInput,
  couponCode,
  addCouponError = false,
  isAuthenticated
}) => {
  const handleRedirect = () => {
    goTo(Routes.userLogin, false, false, [`callredirectUrl=${Routes.checkout}`])
  }

  return (
    <Container fullWidth>
      <Container fullWidth>
        <Container pb="3">
          <TextBody
            size={TextBody.sizes.s}
            {...htmlTranslation(translations, 'tk_CouponCodeLabel')}
          />
          <TextBody
            size={TextBody.sizes.xs}
            {...htmlTranslation(translations, 'tk_CouponCodeDisclaimer')}
          />
        </Container>
        <Container
          fullWidth
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.start}
          position={Container.positions.relative}>
          <Container fullWidth={[true, false, true]}>
            <FieldText
              value={couponCode}
              name={translations.tk_CouponCodeLabel}
              label={translations.tk_EnterCouponCodeLabel}
              onChangeHandler={handleChangeInput}
              disabled={!isAuthenticated}
              data-testing="Cart_FieldText_CouponCode"
              errors={addCouponError ? [translations.tk_couponInputError] : []}
            />
          </Container>
          <Container pl={['3', '3', '4']} pt="1">
            <Button
              variant={Button.variants.secondary}
              text={translations.tk_couponButtonConfirm}
              onClickHandler={handleCouponAction}
              disabled={!couponCode || !isAuthenticated}
              data-testing="Cart_Button_ConfirmCouponCode"
            />
          </Container>
          {!isAuthenticated && (
            <Container
              position={Container.positions.absolute}
              t="0"
              b="0"
              l="0"
              r="0"
              zIndex="2"
              onClickHandler={handleRedirect}
              data-testing="Cart_Overlay_RedirectToLogin"
            />
          )}
        </Container>
      </Container>
    </Container>
  )
}

export default Coupon
